import { PartnerStatus } from 'types/Partner';

export const OTHER_REASONS = 'OTHER_REASONS';
const WITHDRAW_OPTIONS = [
  {
    label: 'Referral is a current JB client',
    value: 'REFERRAL_IS_A_CURRENT_JB_CLIENT',
  },
  {
    label: 'Referral details are not valid',
    value: 'REFERRAL_DETAILS_ARE_NOT_VALID',
  },
  {
    label: 'Referral is associated with negative press/blacklist',
    value: 'REFERRAL_IS_ASSOCIATED_WITH_NEGATIVE_PRESS_BLACKLIST',
  },
  {
    label: 'Referral is a qualified lead',
    value: 'REFERRAL_IS_A_QUALIFIED_LEAD',
  },
  {
    label: 'Lead quality to be checked',
    value: 'LEAD_QUALITY_TO_BE_CHECKED',
  },
];

const REJECTION_OPTIONS = [
  {
    label: 'Pricing mismatch',
    value: 'PRICING_MISMATCH',
  },
  { label: 'Commitment to other bank', value: 'COMMITMENT_TO_OTHER_BANK' },
  { label: 'Offering mismatch', value: 'OFFERING_MISMATCH' },
  {
    label: 'Compliance reasons (e.g. cross-border, sanctions, AML)',
    value: 'COMPLIANCE_REASONS_E_G_CROSS_BORDER_SANCTIONS_AML',
  },
  {
    label: 'Other reasons (please specify in free text fields)',
    value: OTHER_REASONS,
  },
];

export const REASONS_TYPE = {
  [PartnerStatus.WITHDRAWN]: WITHDRAW_OPTIONS,
  [PartnerStatus.REJECTED]: REJECTION_OPTIONS,
};
